export default __webpack_public_path__ + "static/media/cropmonitoring.03b4a549.jpg";